export class RefreshCredentials {
    static jsonMap = {
        refreshToken: { key: 'refreshToken', optional: true, default: '' },
        idOrganisme: { key: 'idOrganisme', optional: true },
        idDomaine: { key: 'idDomaine', optional: true }
    };

    refreshToken: string;
    idOrganisme: number;
    idDomaine: number;
}
